import { OvalLayout, type Layout } from './OvalLayout';

export class OvalsInCanvas {
	private isStarted = false;
	private animationId = -1;

	private isChangingLayout = false;

	private ctx?: CanvasRenderingContext2D | null;
	private canvas?: HTMLCanvasElement;

	public layoutConfig?: Layout;
	public targetLayout?: OvalLayout;
	public currentLayout?: OvalLayout;

	constructor(initialLayout?: Layout) {
		if (initialLayout) this.layoutConfig = initialLayout;
	}

	public set target(canvas: HTMLCanvasElement | undefined) {
		this.canvas = canvas;
		this.ctx = canvas?.getContext('2d');
	}
	public get target() {
		return this.canvas;
	}

	public goto = (layout?: Layout) => {
		this.layoutConfig = layout;
		if (!this.isStarted) return;
		if (this.isChangingLayout) return;

		if (this.currentLayout) {
			this.isChangingLayout = true;
			if (layout) this.targetLayout = new OvalLayout(layout);
			else this.targetLayout = undefined;
			if (this.currentLayout)
				this.currentLayout.destroy().then(() => {
					this.currentLayout = this.targetLayout;
					this.targetLayout = undefined;
					this.isChangingLayout = false;
				});
		} else {
			if (layout) this.currentLayout = new OvalLayout(layout);
		}
	};

	public start = () => {
		if (this.isStarted) return;
		this.isStarted = true;
		this.goto(this.layoutConfig);
		this.tick();
	};

	public stop = () => {
		if (!this.isStarted) return;
		this.isStarted = false;
		window.cancelAnimationFrame(this.animationId);
	};

	private tick = () => {
		window.cancelAnimationFrame(this.animationId);
		if (!this.isStarted || !this.ctx || !this.canvas) return;

		this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

		this.targetLayout?.render(this.ctx, {
			width: this.canvas.width,
			height: this.canvas.height
		});
		this.currentLayout?.render(this.ctx, {
			width: this.canvas.width,
			height: this.canvas.height
		});

		this.animationId = requestAnimationFrame(this.tick);
	};
}
